// assets/product-related.js
// Async load das recomendações via Shopify Recommendations API
(function() {
  const related = document.querySelector('[data-related]');
  if (!related) return;
  const grid = related.querySelector('[data-related-grid]');
  if (!grid || grid.children.length > 0) return;
  const productId = related.dataset.productId;
  const sectionId = related.dataset.sectionId;
  const limit = related.dataset.limit || '4';
  fetch(`/recommendations/products?section_id=${sectionId}&product_id=${productId}&limit=${limit}`)
    .then(r => r.text())
    .then(html => {
      const tmp = document.createElement('div');
      tmp.innerHTML = html;
      const newGrid = tmp.querySelector('[data-related-grid]');
      if (newGrid) grid.innerHTML = newGrid.innerHTML;
    })
    .catch(() => {});
})();
